var exports = {
  "Y": "CtaButtons__uOqnE0",
};

module.exports = exports;
